// Base services
export * from './authentication.service';
export * from './user.service';
export * from './environment.service';
export * from './agreements.service';
export * from './customers.service';
export * from './dealers.service';
export * from './monitorkm.service';
export * from './useradmin.service';
export * from './notificationemails.service';
export * from './pdfcontracts.service';
export * from './serviceaddons.service';
export * from './serviceoffers.service';
export * from './statistics.service';
export * from './tyreAgreements.service';
export * from './tyres.service';
export * from './cars.service';
export * from './customerpermissions.service';
export * from './customertyres.service';
export * from './dormantFeedback.service';
export * from './filters.service';

// Matrix services
export * from './matrix/matrix-calculator.service';
export * from './matrix/matrix-cars.service';

// Matrix product services
export * from './matrix/products/km-catch-up-agreement.service';
export * from './matrix/products/prolongings-agreement.service';
export * from './matrix/products/used-cars-agreement.service';

// Interval services
export * from './interval/service-intervals-matches.service';
export * from './interval/service-intervals.service';


// WEBPACK FOOTER //
// ./src/app/_services/index.ts